import { useContext, useMemo } from 'react'
import { AppDataContext } from '../../../providers/AppData'
import { TENANTS } from '../../../constants/global'

const useLayoutConfig = () => {
  const { locale } = useContext(AppDataContext)

  const displayComponents = useMemo(
    () => ({
      relatedKeywords: locale !== TENANTS.WPA
    }),
    [locale]
  )

  return {
    displayComponents
  }
}

export default useLayoutConfig
